import { useState, useEffect, useContext } from "react";
import { GetStocksForSale } from 'services/stock/stock.service';
import { useSelector, useDispatch } from "react-redux";
import AuthContext from  "../../../context/AuthContext";


const useItemDropdown = () => {
    const { user } = useContext(AuthContext);
    
    const dispatch = useDispatch();
    const { stockList, stockListLoading } = useSelector((state) => state.stockListForSale);
    const [productDropdown, setProductDropdown] = useState([]);


    useEffect(() => {
        dispatch(GetStocksForSale(user.shop_id));
    }, []);

    return {
        productDropdown, 
        setProductDropdown, 
        stockList,
        stockListLoading,
    };
};

export default useItemDropdown;
